export function quillToWord() {
    return "Here is your word document."
}